<template>
    <vue-good-table class="admin-table" :columns="columns" :rows="rows">
      <template slot="table-row" slot-scope="props">
        <div v-if="props.column.field == 'Point'">
          {{ props.formattedRow[props.column.field] }}
        </div>
        <div v-else-if="props.column.field == 'SpentPoint'">
          <div
            v-b-tooltip.hover
            :title="props.formattedRow[props.column.field]"
          >
            {{ props.formattedRow[props.column.field] }}
          </div>
        </div>
        <div v-else-if="props.column.field == 'RemainingPoint'">
          <div
            v-b-tooltip.hover
            :title="props.formattedRow[props.column.field]"
          >
            {{ props.formattedRow[props.column.field] }}
          </div>
        </div>
        <div v-else-if="props.column.field == 'SpentDate'">
          <div
            v-b-tooltip.hover
            :title="props.formattedRow[props.column.field]"
          >
            {{
              props.formattedRow[props.column.field]
            }}
          </div>
        </div>
      </template>
    </vue-good-table>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import { customDateFormatter } from "../../../../helpers";
export default {
  name: "DoinWalletTable",
  data() {
    return {
      isComment: false,
    };
  },
  components: {
    VueGoodTable,
  },
  filters: {
    newDateFormatterFilter(value) {
      return customDateFormatter(value);
    },
  },
  props: {
    doinWallets: {
      type: Array,
    },
    columns: {
      type: Array,
    },
    rows: {
      type: Array,
    },
  },
  methods: {
    tableDetail(row) {
      this.$emit("table-detail", row);
    },
    tableEdit(row) {
      this.$emit("table-edit", row);
    },
    tableDelete(row) {
      this.$emit("table-delete", row);
    },
  },
};
</script>